import React, { useState, useEffect } from 'react';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import { registerUser } from '../../services/services';
import { Helmet } from 'react-helmet';
import { DatePicker, TimePicker, Select, Input, Spin, message, Upload, Button } from 'antd';
import { UploadOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import api from '../../services/api';
import dayjs from 'dayjs';
import axios from 'axios';
import '../../assets/css/register.css';

const { Option } = Select;
const { TextArea } = Input;

const Register = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [childCategories, setChildCategories] = useState([]);
  const [subchildCategories, setSubchildCategories] = useState([]);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [pincodeLoading, setPincodeLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordMatchError, setPasswordMatchError] = useState('');
  const [postOffices, setPostOffices] = useState([]);
  const [state, setState] = useState('');
  const [showOtherCategory, setShowOtherCategory] = useState(false);
  const [showOtherSubCategory, setShowOtherSubCategory] = useState(false);
  const [showOtherChildCategory, setShowOtherChildCategory] = useState(false);
  const [identityDocType, setIdentityDocType] = useState('');

  // Add at top if not present
  const [statesList, setStatesList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const identityDocOptions = [
    { value: 'aadhaar', label: 'Aadhaar' },
    { value: 'pan', label: 'PAN' },
    { value: 'voter_id', label: 'Voter ID' },
    { value: 'passport', label: 'Passport' }
  ];
  const [fileList, setFileList] = useState({
    identityProof: [],
    certificate: [],
    ownershipProof: [],
    businessPhoto: []
  });
  const [uploading, setUploading] = useState(false);

  
// Add this handler to check if passwords match
const handleConfirmPasswordChange = (e) => {
  const value = e.target.value;
  setConfirmPassword(value);
  
  // Validate on each keystroke
  if (form.password && value !== form.password) {
    setPasswordMatchError('Passwords do not match');
  } else {
    setPasswordMatchError('');
  }
};
  const [form, setForm] = useState({
    userType: '',
    // Common fields
    name: '',
    email: '',
    password: '',
    age: '',
    contactNo: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    acceptedTerms: false,

    // Category fields
    parent_category_id: '',
    child_category_id: '',
    subchild_category_id: '',
    otherCategory: '',
    otherSubCategory: '',
    otherChildCategory: '',

    // 3rd Party Services fields
    yearsOfExperience: '',
    expertise: '',
    rating: '',
    // serviceType: '',

    // Partner fields
    gender: '',
    // dob: '',
    panNumber: '',
    aadhaarNumber: '',
    professionalBackground: '',
    industryExperience: '',
    financialCapability: '',
    fundingSource: '',
    skills: '',
    ownershipPreference: '',
    timeCommitment: '',
    pastPartnershipExperience: '',
    legalDisputes: '',
    futureVision: '',
    businessStatus: '',
    identityProofFile: '',

    // Skilled Employee fields
    permanentAddress: '',
    highestQualification: '',
    certificateDetails: '',
    jobSkills: '',
    expectedSalary: '',
    joiningAvailability: '',
    emergencyContactName: '',
    emergencyContactRelation: '',
    emergencyContactNumber: '',
    emergencyContactAddress: '',
    certificateFile: '',

    // Business for Sale fields
    businessName: '',
    businessModel: '',
    bussinesstype: '',
    establishedYear: '',
    reasonForSale: '',
    askingPrice: '',
  askingPriceUnit: 'Lakh', // default value
  annualTurnover: '',
  annualTurnoverUnit: 'Lakh', // default value
  netProfit: '',
  netProfitUnit: 'Lakh', // default value
    assetsIncluded: '',
    liabilities: '',
    numberOfEmployees: '',
    customerBase: '',
    ongoingProjects: '',
    franchiseValidity: '',
    businessRegistrationType: '',
    registrationNumber: '',
    leaseDetails: '',
    address:"",
    preferredContactMode: '',
    priceNegotiable: '',
    ownershipProofFile: '',
    businessPhoto: ''
  });

  // Options for various dropdowns
  const genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'transgender', label: 'Transgender' }
  ];

  const businessStatusOptions = [
    { value: 'running', label: 'Running Business' },
    { value: 'new', label: 'New Business' },
    { value: 'partner_replacement', label: 'Partner Replacement' }
  ];

  const timeCommitmentOptions = [
    { value: 'full_time', label: 'Full-time' },
    { value: 'part_time', label: 'Part-time' }
  ];

  const financialCapabilityOptions = [
    { value: '1-5', label: '₹1-5 Lakhs' },
    { value: '5-10', label: '₹5-10 Lakhs' },
    { value: '10-25', label: '₹10-25 Lakhs' },
    { value: '25-50', label: '₹25-50 Lakhs' },
    { value: '50+', label: '₹50+ Lakhs' }
  ];

  const fundingSourceOptions = [
    { value: 'own', label: 'Own Funds' },
    { value: 'loan', label: 'Loan' },
    { value: 'investor', label: 'Investor' }
  ];

  const qualificationOptions = [
    { value: '10th', label: '10th' },
    { value: '12th', label: '12th' },
    { value: 'diploma', label: 'Diploma' },
    { value: 'graduation', label: 'Graduation' },
    { value: 'post_graduation', label: 'Post Graduation' }
  ];

  const businessModelOptions = [
    { value: 'franchise', label: 'Franchise' },
    { value: 'partnership', label: 'Partnership' },
    { value: 'proprietorship', label: 'Proprietorship' },
    { value: 'private_limited', label: 'Private Limited' },
    { value: 'llp', label: 'LLP' }
  ];

  const registrationTypeOptions = [
    { value: 'gst', label: 'GST' },
    { value: 'roc', label: 'ROC' },
    { value: 'msme', label: 'MSME' },
    { value: 'rera', label: 'RERA' },
    { value: 'other', label: 'Other' }
  ];

  const contactModeOptions = [
    { value: 'call', label: 'Call' },
    { value: 'whatsapp', label: 'WhatsApp' },
    { value: 'email', label: 'Email' }
  ];

  const priceOptions = [
    { value: 'negotiable', label: 'Negotiable' },
    { value: 'fixed', label: 'Fixed Price' }
  ];

  // Fetch categories on component mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const [catRes, childRes, subchildRes] = await Promise.all([
          api.get('/categories'),
          api.get('/child-categories'),
          api.get('/subchild-categories'),
        ]);

        setCategories(catRes.data || []);
        setChildCategories(childRes.data || []);
        setSubchildCategories(subchildRes.data || []);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategories();
  }, []);

  // Handle state city selection control
  useEffect(() => {
    // Fetch list of states in India on mount
    axios.get("https://api.countrystatecity.in/v1/countries/IN/states", {
      headers: {
        "X-CSCAPI-KEY": "T3RzWUFuQkd6em1EZHlQTWlwYUxKb2dPWXlrWDBENnVBcTN2clViaQ==" // Replace with your real API KEY
      }
    })
      .then(res => setStatesList(res.data))
      .catch(() => setStatesList([]));
  }, []);

  const handleStateSelect = (stateCode, stateName) => {
    setForm(prev => ({
      ...prev,
      state: stateName,
      city: '', // reset city when state changes
    }));
    // Fetch cities for the selected state
    axios.get(`https://api.countrystatecity.in/v1/countries/IN/states/${stateCode}/cities`, {
      headers: {
        "X-CSCAPI-KEY": "T3RzWUFuQkd6em1EZHlQTWlwYUxKb2dPWXlrWDBENnVBcTN2clViaQ=="
      }
    }).then(res => setCitiesList(res.data))
      .catch(() => setCitiesList([]));
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
      if (name === 'contactNo') {
    const numbersOnly = value.replace(/\D/g, '').slice(0, 10);
    setForm({ ...form, [name]: numbersOnly });
    return;
  }
    setForm({ ...form, [name]: value });

  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setForm({ ...form, [name]: checked });
    setAcceptedTerms(checked);
  };


  const handleSelectChange = (name, value) => {
    setForm({ ...form, [name]: value });

    // Reset child and subchild when parent changes
    if (name === 'parent_category_id') {
      setForm(prev => ({
        ...prev,
        child_category_id: '',
        subchild_category_id: '',
        otherChildCategory: '',
        otherSubCategory: ''
      }));
      setShowOtherCategory(value === 'other');
    }

    if (name === 'child_category_id') {
      setForm(prev => ({
        ...prev,
        subchild_category_id: '',
        otherSubCategory: ''
      }));
      setShowOtherChildCategory(value === 'other');
    }

    if (name === 'subchild_category_id') {
      setShowOtherSubCategory(value === 'other');
    }
  };

  // File upload configuration
  const fileUploadProps = (fieldName, acceptTypes, maxSize = 5) => ({
    name: fieldName,
    action: `${api.defaults.baseURL}/upload-file?field=${fieldName}`,
    fileList: fileList[fieldName],
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    },
    beforeUpload: (file) => {
      const isAllowedType = acceptTypes.includes(file.type);

      if (!isAllowedType) {
        message.error(`You can only upload ${acceptTypes.join(', ')} files!`);
        return Upload.LIST_IGNORE;
      }

      const isLtMax = file.size / 1024 / 1024 < maxSize;
      if (!isLtMax) {
        message.error(`File must be smaller than ${maxSize}MB!`);
        return Upload.LIST_IGNORE;
      }
      return true;
    },
    onChange: (info) => {
      const newFileList = { ...fileList };
      newFileList[fieldName] = info.fileList;
      setFileList(newFileList);

      if (info.file.status === 'uploading') {
        setUploading(true);
        return;
      }

      if (info.file.status === 'done') {
        setUploading(false);
        if (info.file.response && info.file.response.success) {
          message.success('File uploaded successfully!');
          setForm(prev => ({
            ...prev,
            [fieldName]: info.file.response.fileUrl
          }));
        } else {
          message.error(info.file.response?.message || 'Upload failed!');
        }
      }

      if (info.file.status === 'error') {
        setUploading(false);
        message.error(info.file.response?.message || 'Upload failed!');
      }

      if (info.file.status === 'removed') {
        setForm(prev => ({
          ...prev,
          [fieldName]: ''
        }));
        newFileList[fieldName] = [];
        setFileList(newFileList);
      }
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage('');
    setSuccessMessage('');

    try {
      // Basic validation
      if (!form.email || !form.password || !form.name || !form.userType) {
        setErrorMessage('Email, password, name, and user type are required');
        return;
      }

      if (!form.acceptedTerms) {
        setErrorMessage('You must accept the terms and conditions');
        return;
      }

      // Mobile number validation
if (form.contactNo && !/^\d{10}$/.test(form.contactNo)) {
  setErrorMessage('Contact number must be exactly 10 digits');
  return;
}

      if (!form.pincode || form.pincode.length !== 6) {
        setErrorMessage('Please enter a valid pincode');
        return;
      }
      if (form.password !== confirmPassword) {
  setErrorMessage('Passwords do not match');
  return;
}

      const res = await registerUser(form);

      setSuccessMessage(res.message || 'Registration successful!');

      // Reset form after successful registration
      setForm({
        userType: '',
        name: '',
        email: '',
        password: '',
        age: '',
        contactNo: '',
        address: '',
        city: '',
        state: '',
        pincode: '',
        acceptedTerms: false,
        parent_category_id: '',
        child_category_id: '',
        subchild_category_id: '',
        otherCategory: '',
        otherSubCategory: '',
        otherChildCategory: '',
        yearsOfExperience: '',
        expertise: '',
        rating: '',
        gender: '',
        // dob: '',
        panNumber: '',
        aadhaarNumber: '',
        identityDocType: '',
        identityNumber: '',
        professionalBackground: '',
        industryExperience: '',
        financialCapability: '',
        fundingSource: '',
        skills: '',
        ownershipPreference: '',
        timeCommitment: '',
        pastPartnershipExperience: '',
        legalDisputes: '',
        futureVision: '',
        businessStatus: '',
        identityProofFile: '',
        permanentAddress: '',
        highestQualification: '',
        certificateDetails: '',
        jobSkills: '',
        expectedSalary: '',
        joiningAvailability: '',
        emergencyContactName: '',
        emergencyContactRelation: '',
        emergencyContactNumber: '',
        emergencyContactAddress: '',
        certificateFile: '',
        businessName: '',
        businessModel: '',
        bussinesstype: '',
        establishedYear: '',
        reasonForSale: '',
        askingPrice: '',
        annualTurnover: '',
        netProfit: '',
        assetsIncluded: '',
        liabilities: '',
        numberOfEmployees: '',
        customerBase: '',
        ongoingProjects: '',
        franchiseValidity: '',
        businessRegistrationType: '',
        registrationNumber: '',
        leaseDetails: '',
        address:"",
        preferredContactMode: '',
        priceNegotiable: '',
        ownershipProofFile: '',
        businessPhoto: ''
      });

      setFileList({
        identityProof: [],
        certificate: [],
        ownershipProof: [],
        businessPhoto: []
      });

      setPostOffices([]);
      setState('');
      setConfirmPassword('');
setPasswordMatchError('');
      setAcceptedTerms(false);
    } catch (err) {
      const errorMsg = err.response?.data?.message ||
        err.message ||
        'Registration failed. Please try again.';
      setErrorMessage(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  // Filter child categories based on selected parent category AND user type
  const filteredChildCategories = form.parent_category_id && form.parent_category_id !== 'other'
    ? childCategories.filter(cat =>
      cat.parent_category_id === form.parent_category_id
    )
    : [];

  // Filter subchild categories based on selected child category AND user type  
  const filteredSubchildCategories = form.child_category_id && form.child_category_id !== 'other'
    ? subchildCategories.filter(cat =>
      cat.child_category_id === form.child_category_id
    )
    : [];
  // Render common fields
  const renderCommonFields = () => (
    <>
      <div className="col-lg-4">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="name">Name *</label>
          <input
            id="name"
            type="text"
            className="form-control"
            placeholder="Name *"
            name="name"
            value={form.name}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      <div className="col-lg-4">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="email">Email *</label>
          <input
            id="email"
            type="email"
            className="form-control"
            placeholder="Email *"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      <div className="col-lg-4">


        <div style={{ position: "relative", marginBottom: '1rem' }}>
          <label
            htmlFor="password"
            style={{ marginBottom: "0.5rem", fontWeight: "500" }}
          >
            Password *
          </label>
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Password *"
            name="password"
            value={form.password}
            onChange={handleChange}
            style={{
              padding: "8px 40px 8px 12px", // extra right padding for icon
              border: "1px solid #ccc",
              borderRadius: "4px",
              fontSize: "14px",
              outline: "none",
            }} // space for icon


            className="form-control pr-10"
            required
          />

          <span
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              right: "10px",
              top: "70%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#888",
            }}
          >
            {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
          </span>
        </div>
      </div>
      <div className="col-lg-4">
        <div style={{ position: "relative", marginBottom: '1rem' }}>
          <label
            htmlFor="confirmPassword"
            style={{ marginBottom: "0.5rem", fontWeight: "500" }}
          >
            Confirm Password *
          </label>
          <input
            id="confirmPassword"
            type={showConfirmPassword ? "text" : "password"}
            placeholder="Confirm Password *"
            value={confirmPassword}
            onChange={handleConfirmPasswordChange}
            style={{
              padding: "8px 40px 8px 12px",
              border: passwordMatchError ? "1px solid #dc3545" : "1px solid #ccc",
              borderRadius: "4px",
              fontSize: "14px",
              outline: "none",
              width: "100%"
            }}
            className="form-control pr-10"
            required
          />
          <span
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            style={{
              position: "absolute",
              right: "10px",
              top: "70%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#888",
            }}
          >
            {showConfirmPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
          </span>
          {passwordMatchError && (
            <small style={{ color: "#dc3545", display: "block", marginTop: "5px" }}>
              {passwordMatchError}
            </small>
          )}
        </div>
      </div>

      <div className="col-lg-4">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="age">Age</label>
          <input
            id="age"
            type="number"
            className="form-control"
            placeholder="Age"
            name="age"
            value={form.age}
            onChange={handleChange}
          />
        </div>
      </div>

<div className="col-lg-4">
  <div className="form-group" style={{ marginBottom: '1rem' }}>
    <label htmlFor="contactNo">Contact No *</label>
    <input
      id="contactNo"
      type="tel"
      className="form-control"
      placeholder="Contact No *"
      name="contactNo"
      value={form.contactNo}
      onChange={handleChange}
      maxLength="10"
      pattern="[0-9]{10}"
      title="Please enter exactly 10 digits"
      required
    />
    <small className="text-muted">Must be 10 digits</small>
  </div>
</div>


      {/* State Selection */}
      <div className="col-lg-4">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="state">State *</label>
          <Select
            id="state"
            showSearch
            placeholder="Select State"
            optionFilterProp="children"
            className="w-100"
            value={form.state || undefined}
            onChange={(value, option) => handleStateSelect(option.value, option.children)}
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {statesList.map(state =>
              <Option key={state.iso2} value={state.iso2}>{state.name}</Option>
            )}
          </Select>
        </div>
      </div>

      {/* City Selection */}
      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="city">City *</label>
          <Select
            id="city"
            showSearch
            placeholder="Select City"
            optionFilterProp="children"
            className="w-100"
            value={form.city || undefined}
            onChange={(value) => handleSelectChange('city', value)}
            disabled={!form.state}
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {citiesList.map(city =>
              <Option key={city.id} value={city.name}>{city.name}</Option>
            )}
          </Select>
        </div>
      </div>

      {/* Pincode Input */}
      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="pincode">Pincode *</label>
          <input
            id="pincode"
            type="text"
            className="form-control"
            placeholder="Enter pincode *"
            name="pincode"
            value={form.pincode}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      {/* Address Fields */}

    </>
  );

// Update the renderCategoryFields function with labels
const renderCategoryFields = () => {
  // Filter categories based on selected user type - UPDATED LOGIC
  const filteredCategories = form.userType
    ? categories.filter(cat => {
        // Check if user_types exists and contains the selected user type
        if (cat.user_types) {
          const userTypesArray = cat.user_types.split(',');
          return userTypesArray.includes(form.userType);
        }
        return false;
      })
    : [];

  return (
    <>
      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="parent_category_id">Category</label>
          <Select
            id="parent_category_id"
            className="w-100"
            placeholder="Select Category"
            value={form.parent_category_id || undefined}
            onChange={(value) => handleSelectChange('parent_category_id', value)}
            disabled={!form.userType} // Disable until user type is selected
          >
            {filteredCategories.map(cat => (
              <Option key={cat.id} value={cat.id}>{cat.name}</Option>
            ))}
            <Option key="other" value="other">Other</Option>
          </Select>
        </div>
      </div>

      {showOtherCategory && (
        <div className="col-lg-6">
          <div className="form-group" style={{ marginBottom: '1rem' }}>
            <label htmlFor="otherCategory">Other Category</label>
            <input
              id="otherCategory"
              type="text"
              className="form-control"
              placeholder="Enter your other category"
              name="otherCategory"
              value={form.otherCategory}
              onChange={handleChange}
              required
            />
          </div>
        </div>
      )}

      {form.parent_category_id && form.parent_category_id !== 'other' && (
        <>
          <div className="col-lg-6">
            <div className="form-group" style={{ marginBottom: '1rem' }}>
              <label htmlFor="child_category_id">Sub Category</label>
              <Select
                id="child_category_id"
                className="w-100"
                placeholder="Select Sub Category"
                value={form.child_category_id || undefined}
                onChange={(value) => handleSelectChange('child_category_id', value)}
              >
                {filteredChildCategories.map(cat => (
                  <Option key={cat.id} value={cat.id}>{cat.name}</Option>
                ))}
                <Option key="other" value="other">Other</Option>
              </Select>
            </div>
          </div>

          {showOtherChildCategory && (
            <div className="col-lg-6">
              <div className="form-group" style={{ marginBottom: '1rem' }}>
                <label htmlFor="otherChildCategory">Other Sub Category</label>
                <input
                  id="otherChildCategory"
                  type="text"
                  className="form-control"
                  placeholder="Enter your other sub category"
                  name="otherChildCategory"
                  value={form.otherChildCategory}
                  onChange={handleChange}
                />
              </div>
            </div>
          )}

          {form.child_category_id && form.child_category_id !== 'other' && (
            <>
              <div className="col-lg-6">
                <div className="form-group" style={{ marginBottom: '1rem' }}>
                  <label htmlFor="subchild_category_id">Child Sub Category</label>
                  <Select
                    id="subchild_category_id"
                    className="w-100"
                    placeholder="Select Child Sub Category"
                    value={form.subchild_category_id || undefined}
                    onChange={(value) => handleSelectChange('subchild_category_id', value)}
                  >
                    {filteredSubchildCategories.map(cat => (
                      <Option key={cat.id} value={cat.id}>{cat.name}</Option>
                    ))}
                    <Option key="other" value="other">Other</Option>
                  </Select>
                </div>
              </div>

              {showOtherSubCategory && (
                <div className="col-lg-6">
                  <div className="form-group" style={{ marginBottom: '1rem' }}>
                    <label htmlFor="otherSubCategory">Other Child Sub Category</label>
                    <input
                      id="otherSubCategory"
                      type="text"
                      className="form-control"
                      placeholder="Enter your other child sub category"
                      name="otherSubCategory"
                      value={form.otherSubCategory}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};


  // Update the renderThirdPartyForm function with labels
  const renderThirdPartyForm = () => (
    <>
      {renderCommonFields()}
      {renderCategoryFields()}
      <div className="col-lg-12">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="address"> Current Address *</label>
          <input
            id="address"
            type="text"
            className="form-control"
            placeholder="Enter your Current address *"
            name="address"
            value={form.address}
            onChange={handleChange}
            required
          />
        </div>
      </div>
      <div className="col-lg-4">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="yearsOfExperience">Years of Experience</label>
          <input
            id="yearsOfExperience"
            type="text"
            className="form-control"
            placeholder="Years of Experience"
            name="yearsOfExperience"
            value={form.yearsOfExperience}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="col-lg-4">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="expertise">Expertise (if any)</label>
          <input
            id="expertise"
            type="text"
            className="form-control"
            placeholder="Expertise (if any)"
            name="expertise"
            value={form.expertise}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* <div className="col-lg-4">
      <div className="form-group" style={{ marginBottom: '1rem' }}>
        <label htmlFor="rating">Rating</label>
        <input
          id="rating"
          type="text"
          className="form-control"
          placeholder="Rating"
          name="rating"
          value={form.rating}
          onChange={handleChange}
        />
      </div>
    </div> */}



    </>
  );

  // Update the renderPartnerForm function with labels
  const renderPartnerForm = () => (
    <>
      {renderCommonFields()}
      <div className="col-lg-12">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="address"> Current Address *</label>
          <input
            id="address"
            type="text"
            className="form-control"
            placeholder="Enter your Current address *"
            name="address"
            value={form.address}
            onChange={handleChange}
            required
          />
        </div>
      </div>
      <div className="col-lg-12">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="bussinesstype">Partner Match *</label>
          <select
            id="bussinesstype"
            name="bussinesstype"
            className="form-control"
            value={form.bussinesstype}
            onChange={handleChange}>
            <option value="">Select Partner Match *</option>
            <option value="Regular Business Partner">Regular Business Partner</option>
            <option value="Startup">Startup</option>
            <option value="Franchise">Franchise</option>
          </select>
        </div>
      </div>
      {/* <div className="col-lg-4">
      <div className="form-group" style={{ marginBottom: '1rem' }}>
        <label htmlFor="dob">Date of Birth</label>
        <DatePicker
          id="dob"
          className="w-100"
          placeholder="Date of Birth"
          onChange={(date, dateString) => handleSelectChange('dob', dateString)}
        />
      </div>
    </div> */}

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="gender">Gender</label>
          <Select
            id="gender"
            className="w-100"
            placeholder="Select Gender"
            value={form.gender || undefined}
            onChange={(value) => handleSelectChange('gender', value)}
          >
            {genderOptions.map(option => (
              <Option key={option.value} value={option.value}>{option.label}</Option>
            ))}
          </Select>
        </div>
      </div>

      {renderCategoryFields()}

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="identityDocType">Identity Document Type *</label>
          <Select
            id="identityDocType"
            className="w-100"
            placeholder="Select Document Type"
            value={identityDocType || undefined}
            onChange={(value) => setIdentityDocType(value)}
          >
            {identityDocOptions.map(option => (
              <Option key={option.value} value={option.value}>{option.label}</Option>
            ))}
          </Select>
        </div>
      </div>

      {identityDocType && (
        <div className="col-lg-6">
          <div className="form-group" style={{ marginBottom: '1rem' }}>
            <label htmlFor="identityNumber">
              {identityDocType === 'aadhaar' && 'Aadhaar Number'}
              {identityDocType === 'pan' && 'PAN Number'}
              {identityDocType === 'voter_id' && 'Voter ID Number'}
              {identityDocType === 'passport' && 'Passport Number'} *
            </label>
            <input
              id="identityNumber"
              type="text"
              className="form-control"
              placeholder={
                identityDocType === 'aadhaar' ? 'Aadhaar Number' :
                  identityDocType === 'pan' ? 'PAN Number' :
                    identityDocType === 'voter_id' ? 'Voter ID Number' : 'Passport Number'
              }
              name="identityNumber"
              value={form.identityNumber}
              onChange={handleChange}
              required
            />
          </div>
        </div>
      )}

      <div className="col-lg-12">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label>Identity Proof (Upload {identityDocType ? identityDocOptions.find(d => d.value === identityDocType)?.label : 'Document'})</label>
          <Upload {...fileUploadProps('identityProofFile',
            ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'])}>
            <Button icon={<UploadOutlined />} disabled={uploading}>
              {uploading ? 'Uploading...' : `Upload ${identityDocType ? identityDocOptions.find(d => d.value === identityDocType)?.label : 'Document'}`}
            </Button>
          </Upload>
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="professionalBackground">Current Occupation/Business</label>
          <Select
            id="professionalBackground"
            className="w-100"
            placeholder="Any Current Occupation/Business "
            value={form.professionalBackground || undefined}
            onChange={(value) => handleSelectChange('professionalBackground', value)}
          >
            <Option value="Job">Job</Option>
            <Option value="Business">Business</Option>
            <Option value="Self-Employed">Self-Employed</Option>
            <Option value="Not Working">Not Working</Option>
          </Select>
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="industryExperience">Industry Experience (years)</label>
          <input
            id="industryExperience"
            type="text"
            className="form-control"
            placeholder="Industry Experience (years)"
            name="industryExperience"
            value={form.industryExperience}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="financialCapability">Financial Capability</label>
          <Select
            id="financialCapability"
            className="w-100"
            placeholder="Financial Capability"
            value={form.financialCapability || undefined}
            onChange={(value) => handleSelectChange('financialCapability', value)}
          >
            {financialCapabilityOptions.map(option => (
              <Option key={option.value} value={option.value}>{option.label}</Option>
            ))}
          </Select>
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="fundingSource">Funding Source</label>
          <Select
            id="fundingSource"
            className="w-100"
            placeholder="Funding Source"
            value={form.fundingSource || undefined}
            onChange={(value) => handleSelectChange('fundingSource', value)}
          >
            {fundingSourceOptions.map(option => (
              <Option key={option.value} value={option.value}>{option.label}</Option>
            ))}
          </Select>
        </div>
      </div>

      <div className="col-lg-12">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="skills">Skills & Expertise</label>
          <TextArea
            id="skills"
            placeholder="Skills & Expertise"
            name="skills"
            value={form.skills}
            onChange={handleChange}
            rows={3}
          />
        </div>
      </div>

      <div className="col-lg-4">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="ownershipPreference">Ownership Preference (%)</label>
          <input
            id="ownershipPreference"
            type="text"
            className="form-control"
            placeholder="Ownership Preference (%)"
            name="ownershipPreference"
            value={form.ownershipPreference}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="col-lg-4">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="timeCommitment">Time Commitment</label>
          <Select
            id="timeCommitment"
            className="w-100"
            placeholder="Time Commitment"
            value={form.timeCommitment || undefined}
            onChange={(value) => handleSelectChange('timeCommitment', value)}
          >
            {timeCommitmentOptions.map(option => (
              <Option key={option.value} value={option.value}>{option.label}</Option>
            ))}
          </Select>
        </div>
      </div>

      <div className="col-lg-4">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="businessStatus">Business Status</label>
          <Select
            id="businessStatus"
            className="w-100"
            placeholder="Business Status"
            value={form.businessStatus || undefined}
            onChange={(value) => handleSelectChange('businessStatus', value)}
          >
            {businessStatusOptions.map(option => (
              <Option key={option.value} value={option.value}>{option.label}</Option>
            ))}
          </Select>
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="pastPartnershipExperience">Past Partnership Experience</label>
          <Select
            id="pastPartnershipExperience"
            className="w-100"
            placeholder="Past Partnership Experience"
            value={form.pastPartnershipExperience || undefined}
            onChange={(value) => handleSelectChange('pastPartnershipExperience', value)}
          >
            <Option value="yes">Yes</Option>
            <Option value="no">No</Option>
          </Select>
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="legalDisputes">Any Legal Disputes</label>
          <Select
            id="legalDisputes"
            className="w-100"
            placeholder="Any Legal Disputes"
            value={form.legalDisputes || undefined}
            onChange={(value) => handleSelectChange('legalDisputes', value)}
          >
            <Option value="yes">Yes</Option>
            <Option value="no">No</Option>
            <Option value="Prefer not to disclose">Prefer not to disclose</Option>
          </Select>
        </div>
      </div>

      <div className="col-lg-12">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="futureVision">Select Business Vision</label>

          <Select
            id="futureVision"
            className="w-100"
            placeholder="Future Business Vision (Short-term and Long-term goals)"
            name="futureVision"

            value={form.futureVision || undefined}
            onChange={(value) => handleSelectChange('futureVision', value)}


          >

            <Option value="Short-Term"> Short Term</Option>
            <Option value="Long-Term"> Long Term</Option>

          </Select>
        </div>
      </div>
    </>
  );

  // Update the renderEmployeeForm function with labels
  const renderEmployeeForm = () => (
    <>
      {renderCommonFields()}

      {/* <div className="col-lg-4">
      <div className="form-group" style={{ marginBottom: '1rem' }}>
        <label htmlFor="dob">Date of Birth</label>
        <DatePicker
          id="dob"
          className="w-100"
          placeholder="Date of Birth"
          onChange={(date, dateString) => handleSelectChange('dob', dateString)}
        />
      </div>
    </div> */}

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="gender">Gender</label>
          <Select
            id="gender"
            className="w-100"
            placeholder="Select Gender"
            value={form.gender || undefined}
            onChange={(value) => handleSelectChange('gender', value)}
          >
            {genderOptions.map(option => (
              <Option key={option.value} value={option.value}>{option.label}</Option>
            ))}
          </Select>
        </div>
      </div>

      <div className="col-lg-12">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="permanentAddress">Permanent Address</label>
          <input
            id="permanentAddress"
            type="text"
            className="form-control"
            placeholder="Permanent Address"
            name="permanentAddress"
            value={form.permanentAddress}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="aadhaarNumber">Aadhaar Number</label>
          <input
            id="aadhaarNumber"
            type="text"
            className="form-control"
            placeholder="Aadhaar Number"
            name="aadhaarNumber"
            value={form.aadhaarNumber}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="panNumber">PAN Number</label>
          <input
            id="panNumber"
            type="text"
            className="form-control"
            placeholder="PAN Number"
            name="panNumber"
            value={form.panNumber}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="highestQualification">Highest Qualification</label>
          <Select
            id="highestQualification"
            className="w-100"
            placeholder="Highest Qualification"
            value={form.highestQualification || undefined}
            onChange={(value) => handleSelectChange('highestQualification', value)}
          >
            {qualificationOptions.map(option => (
              <Option key={option.value} value={option.value}>{option.label}</Option>
            ))}
          </Select>
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="certificateDetails">Certificate (if any) - otherwise NA</label>
          <input
            id="certificateDetails"
            type="text"
            className="form-control"
            placeholder="Certificate Details"
            name="certificateDetails"
            value={form.certificateDetails}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="col-lg-12">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label>Upload highest degree/certificate</label>
          <Upload {...fileUploadProps('ownershipProofFile',
            ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'])}>
            <Button icon={<UploadOutlined />} disabled={uploading}>
              {uploading ? 'Uploading...' : 'Upload Certificate'}
            </Button>
          </Upload>
        </div>
      </div>

      {renderCategoryFields()}

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="jobSkills">Skills / Expertise</label>
          <TextArea
            id="jobSkills"
            placeholder="Skills / Expertise"
            name="jobSkills"
            value={form.jobSkills}
            onChange={handleChange}
            rows={3}
          />
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="yearsOfExperience">Years of Experience</label>
          <input
            id="yearsOfExperience"
            type="text"
            className="form-control"
            placeholder="Years of Experience"
            name="yearsOfExperience"
            value={form.yearsOfExperience}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="expectedSalary">Expected Salary</label>
          <input
            id="expectedSalary"
            type="text"
            className="form-control"
            placeholder="Expected Salary"
            name="expectedSalary"
            value={form.expectedSalary}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="joiningAvailability">Joining Availability</label>
          <select
            id="joiningAvailability"
            className="form-control"
            name="joiningAvailability"
            value={form.joiningAvailability}
            onChange={handleChange}
          >
            <option value="">Select Availability</option>
            <option value="Immediate Joiner">Immediate Joiner</option>
            <option value="Notice period">Notice period</option>
          </select>
        </div>
      </div>

      {form.joiningAvailability === "Notice period" && (
        <div className="col-lg-6">
          <div className="form-group" style={{ marginBottom: '1rem' }}>
            <label htmlFor="noticePeriodDays">Notice Period (Days)</label>
            <input
              id="noticePeriodDays"
              type="number"
              className="form-control"
              placeholder="Enter number of days"
              name="noticePeriodDays"
              value={form.noticePeriodDays}
              onChange={handleChange}
              min="1"
            />
          </div>
        </div>
      )}

      <div className="col-lg-12">
        <h5>Emergency Contact</h5>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="emergencyContactName">Name</label>
          <input
            id="emergencyContactName"
            type="text"
            className="form-control"
            placeholder="Name"
            name="emergencyContactName"
            value={form.emergencyContactName}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="emergencyContactRelation">Relation</label>
          <input
            id="emergencyContactRelation"
            type="text"
            className="form-control"
            placeholder="Relation"
            name="emergencyContactRelation"
            value={form.emergencyContactRelation}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="emergencyContactNumber">Mobile Number</label>
          <input
            id="emergencyContactNumber"
            type="text"
            className="form-control"
            placeholder="Mobile Number"
            name="emergencyContactNumber"
            value={form.emergencyContactNumber}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="sameAsPermanent">Is Emergency Address Same as Permanent?</label>
          <select
            id="sameAsPermanent"
            className="form-control"
            name="sameAsPermanent"
            value={form.sameAsPermanent}
            onChange={handleChange}
          >
            <option value="">Select Option</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>
      </div>

      {form.sameAsPermanent === "no" && (
        <div className="col-lg-6">
          <div className="form-group" style={{ marginBottom: '1rem' }}>
            <label htmlFor="emergencyContactAddress">Emergency Address</label>
            <input
              id="emergencyContactAddress"
              type="text"
              className="form-control"
              placeholder="Emergency Address"
              name="emergencyContactAddress"
              value={form.emergencyContactAddress}
              onChange={handleChange}
              required={form.sameAsPermanent === "no"}
            />
          </div>
        </div>
      )}
    </>
  );

  // Update the renderBusinessForm function with labels
  const renderBusinessForm = () => (
    <>
      {renderCommonFields()}

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="businessName">Business Name *</label>
          <input
            id="businessName"
            type="text"
            className="form-control"
            placeholder="Business Name *"
            name="businessName"
            value={form.businessName}
            onChange={handleChange}
            required
          />
        </div>
      </div>


      {renderCategoryFields()}

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="businessModel">Business Model *</label>
          <Select
            id="businessModel"
            className="w-100"
            placeholder="Business Model *"
            value={form.businessModel || undefined}
            onChange={(value) => handleSelectChange('businessModel', value)}
          >
            {businessModelOptions.map(option => (
              <Option key={option.value} value={option.value}>{option.label}</Option>
            ))}
          </Select>
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="establishedYear">Established Year</label>
          <DatePicker
            id="establishedYear"
            className="w-100"
            placeholder="Established Year"
            picker="year"
            onChange={(date, dateString) => handleSelectChange('establishedYear', dateString)}
          />
        </div>
      </div>

      <div className="col-lg-12">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="reasonForSale">Reason for Sale</label>
          <TextArea
            id="reasonForSale"
            placeholder="Reason for Sale"
            name="reasonForSale"
            value={form.reasonForSale}
            onChange={handleChange}
            rows={3}
          />
        </div>
      </div>

<div className="col-lg-4">
  <div className="form-group" style={{ marginBottom: '1rem' }}>
    <label htmlFor="askingPrice">Asking Price *</label>
    <div className="input-group">
      <input
        id="askingPrice"
        type="text"
        className="form-control"
        placeholder="Enter amount"
        name="askingPrice"
        value={form.askingPrice}
        onChange={handleChange}
        required
      />
      <select
        name="askingPriceUnit"
        className="form-control"
        value={form.askingPriceUnit}
        onChange={handleChange}
        style={{ maxWidth: '120px' }}
      >
        <option value="Thousand">Thousand</option>
        <option value="Lakh">Lakh</option>
        <option value="Crore">Crore</option>
      </select>
    </div>
  </div>
</div>

<div className="col-lg-4">
  <div className="form-group" style={{ marginBottom: '1rem' }}>
    <label htmlFor="annualTurnover">Annual Turnover (approx) *</label>
    <div className="input-group">
      <input
        id="annualTurnover"
        type="text"
        className="form-control"
        placeholder="Enter amount"
        name="annualTurnover"
        value={form.annualTurnover}
        onChange={handleChange}
        required
      />
      <select
        name="annualTurnoverUnit"
        className="form-control"
        value={form.annualTurnoverUnit}
        onChange={handleChange}
        style={{ maxWidth: '120px' }}
      >
        <option value="Thousand">Thousand</option>
        <option value="Lakh">Lakh</option>
        <option value="Crore">Crore</option>
      </select>
    </div>
  </div>
</div>

<div className="col-lg-4">
  <div className="form-group" style={{ marginBottom: '1rem' }}>
    <label htmlFor="netProfit">Net Profit (optional)</label>
    <div className="input-group">
      <input
        id="netProfit"
        type="text"
        className="form-control"
        placeholder="Enter amount"
        name="netProfit"
        value={form.netProfit}
        onChange={handleChange}
      />
      <select
        name="netProfitUnit"
        className="form-control"
        value={form.netProfitUnit}
        onChange={handleChange}
        style={{ maxWidth: '120px' }}
      >
        <option value="Thousand">Thousand</option>
        <option value="Lakh">Lakh</option>
        <option value="Crore">Crore</option>
      </select>
    </div>
  </div>
</div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="assetsIncluded">Assets Included (Machinery, Furniture, Inventory, Office Setup, etc.) *</label>
          <TextArea
            id="assetsIncluded"
            placeholder="Assets Included (Machinery, Furniture, Inventory, Office Setup, etc.) *"
            name="assetsIncluded"
            value={form.assetsIncluded}
            onChange={handleChange}
            rows={3}
            required
          />
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="liabilities">Liabilities (if any otherwise N/A) *</label>
          <TextArea
            id="liabilities"
            placeholder="Liabilities (if any otherwise N/A) *"
            name="liabilities"
            value={form.liabilities}
            onChange={handleChange}
            rows={3}
            required
          />
        </div>
      </div>

      <div className="col-lg-4">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="numberOfEmployees">Number of Employees</label>
          <input
            id="numberOfEmployees"
            type="number"
            className="form-control"
            placeholder="Number of Employees"
            name="numberOfEmployees"
            value={form.numberOfEmployees}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="col-lg-4">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="customerBase">Customer Base / Client Contracts	</label>
          <select
            id="customerBase"
            name="customerBase"
            className="form-control"
            value={form.customerBase}
            onChange={handleChange}
          >
            <option value="">Select</option>
            <option value="Customer Base">Customer Base</option>
            <option value="Client Contracts">Client Contracts</option>
          </select>
        </div>
      </div>


      <div className="col-lg-4">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="ongoingProjects">Ongoing Projects (if any)</label>
          <input
            id="ongoingProjects"
            type="text"
            className="form-control"
            placeholder="Ongoing Projects (if any)"
            name="ongoingProjects"
            value={form.ongoingProjects}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="franchiseValidity">Franchise/License Validity (if franchise business)</label>
          <input
            id="franchiseValidity"
            type="text"
            className="form-control"
            placeholder="Franchise/License Validity (if franchise business)"
            name="franchiseValidity"
            value={form.franchiseValidity}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="col-lg-12">
        <h3>Legal / Document Info</h3>
      </div>

      <div className="col-lg-4">

        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="businessRegistrationType">Business Registration Type *</label>
          <Select
            id="businessRegistrationType"
            className="w-100"
            placeholder="Business Registration Type *"
            value={form.businessRegistrationType || undefined}
            onChange={(value) => handleSelectChange('businessRegistrationType', value)}
          >
            {registrationTypeOptions.map(option => (
              <Option key={option.value} value={option.value}>{option.label}</Option>
            ))}
          </Select>
        </div>
      </div>

      <div className="col-lg-4">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="registrationNumber">Registration Number *</label>
          <input
            id="registrationNumber"
            type="text"
            className="form-control"
            placeholder="Registration Number *"
            name="registrationNumber"
            value={form.registrationNumber}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      <div className="col-lg-4">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="leaseDetails">Lease/Rent Agreement Details (if applicable)</label>
          <TextArea
            id="leaseDetails"
            placeholder="Lease/Rent Agreement Details (if applicable)"
            name="leaseDetails"
            value={form.leaseDetails}
            onChange={handleChange}
            rows={3}
          />
        </div>
      </div>

      <div className="col-lg-4">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="address"> Address *</label>
          <input
            id="address"
            type="text"
            className="form-control"
            placeholder="Address *"
            name="address"
            value={form.address}
            onChange={handleChange}
            required
          />
        </div>
      </div>
      <div className="col-lg-4">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label>Upload Ownership Proof Documents</label>
          <Upload {...fileUploadProps('ownershipProofFile',
            ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'])}>
            <Button icon={<UploadOutlined />} disabled={uploading}>
              {uploading ? 'Uploading...' : 'Upload Ownership Proof'}
            </Button>
          </Upload>
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="contactNo">Owner's Contact *</label>
          <input
            id="contactNo"
            type="text"
            className="form-control"
            placeholder="Owner's Contact *"
            name="contactNo"
            value={form.contactNo}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="preferredContactMode">Preferred Mode of Contact</label>
          <Select
            id="preferredContactMode"
            className="w-100"
            placeholder="Preferred Mode of Contact"
            value={form.preferredContactMode || undefined}
            onChange={(value) => handleSelectChange('preferredContactMode', value)}
          >
            {contactModeOptions.map(option => (
              <Option key={option.value} value={option.value}>{option.label}</Option>
            ))}
          </Select>
        </div>
      </div>

      <div className="col-lg-12">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label>Upload Business Photo</label>
          <Upload {...fileUploadProps('businessPhoto',
            ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'])}>
            <Button icon={<UploadOutlined />} disabled={uploading}>
              {uploading ? 'Uploading...' : 'Upload Business Photo'}
            </Button>
          </Upload>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label htmlFor="priceNegotiable">Negotiable or Fixed Price</label>
          <Select
            id="priceNegotiable"
            className="w-100"
            placeholder="Negotiable or Fixed Price"
            value={form.priceNegotiable || undefined}
            onChange={(value) => handleSelectChange('priceNegotiable', value)}
          >
            {priceOptions.map(option => (
              <Option key={option.value} value={option.value}>{option.label}</Option>
            ))}
          </Select>
        </div>
      </div>
    </>
  );


  // Render form based on selected user type
  const renderFormByUserType = () => {
    switch (form.userType) {
      case '3rd Party Services':
        return renderThirdPartyForm();
      case 'Partner':
        return renderPartnerForm();
      case 'Employee':
        return renderEmployeeForm();
      case 'Business':
        return renderBusinessForm();
      default:
        return null;
    }
  };

  return (

    <>
      <Helmet>
        <title>Register - Startup Business Partners</title>
      </Helmet>
      <Navbar />
      <br />
      <br />
      <div className="login-form d-flex align-items-center" style={{ marginBottom: '2rem' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="form-wrapper">
                <div className="card card-shadow">
                  <div className="card-header" style={{ marginBottom: '1rem' }}>
                    <br />
                    <h4 className="text-center">Register Here!</h4>
                  </div>
                  <div className="card-body">
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        {/* User Type Selection */}
                        <div className="col-lg-12">
                          <div className="form-group" style={{ marginBottom: '1rem' }}>
                            <label htmlFor="userType">User Type *</label>
                            <select
                              id="userType"
                              name="userType"
                              className="form-control"
                              value={form.userType}
                              onChange={handleChange}
                              required
                              style={{
                                width: '100%',
                                padding: '0px 14px',
                                fontSize: '16px',
                                border: '2px solid #ccc',
                                borderRadius: '8px',
                                outline: 'none',
                                transition: 'all 0.3s ease',
                                backgroundColor: '#fff',
                                color: '#333',
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                                appearance: 'none',
                                backgroundImage:
                                  'linear-gradient(45deg, transparent 50%, #555 50%), linear-gradient(135deg, #555 50%, transparent 50%)',
                                backgroundPosition: 'calc(100% - 20px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px)',
                                backgroundSize: '5px 5px, 5px 5px',
                                backgroundRepeat: 'no-repeat',
                                cursor: 'pointer',
                              }}
                              onFocus={(e) => (e.target.style.borderColor = '#007BFF')}
                              onBlur={(e) => (e.target.style.borderColor = '#ccc')}
                              onMouseOver={(e) => (e.target.style.boxShadow = '0 0 8px rgba(0, 123, 255, 0.2)')}
                              onMouseOut={(e) => (e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)')}
                            >
                              <option value="">Select User Type *</option>
                              <option value="3rd Party Services">3rd Party Services</option>
                              <option value="Partner">Partner</option>
                              <option value="Employee">Skilled Business Employee</option>
                              <option value="Business">Business For Sale</option>
                            </select>
                          </div>
                        </div>

                        {/* Render form based on user type */}
                        {renderFormByUserType()}

                        {/* Terms and Conditions */}
                        <div className="col-lg-12">
                          <div className="form-group form-check" style={{ marginBottom: '1rem' }}>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="acceptTerms"
                              name="acceptedTerms"
                              checked={form.acceptedTerms}
                              onChange={handleCheckboxChange}
                              required
                            />
                            <label className="form-check-label" htmlFor="acceptTerms">
                              I agree to the <a href="/termscondition" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="form-group text-center m-bottom-20">
                        <button
                          className="btn btn-secondary"
                          type="submit"
                          disabled={loading || !form.state || uploading}
                        >
                          {loading ? 'Registering...' : 'Register'}
                        </button>
                      </div>
                    </form>
                    <p className="text-center m-bottom-25">
                      Already have an account? <a href="/login">Login</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Register;